import * as yup from 'yup';

export const RCMVariavelSchema = yup.object({
  opcaoRCM: yup.bool().oneOf([true], 'Atenção, Clique em Opção RCM'),
});

export const RCMVariavelInitialValues = {
  opcaoRCM: false,
};
